import Response from '@app/types/src/schema/Response'
import axios from 'axios'
import firebase from 'firebase'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { devices } from '@app/constants/DeviceType'
import { Address } from '@app/types/src/Address'
import { Flag } from 'types/src/common'
import { $axios } from '@app/utils/api'
import { getExtentionName, uploadStorage } from '@app/utils/image'
import { getUUID } from '@app/utils/uuid'
import { RepairStatus, ReturnType } from '@app/types/src/repair'

@Module({
  name: 'repair',
  stateFactory: true,
  namespaced: true,
})
export default class RepairModule extends VuexModule {
  isInput: boolean = false

  id: string = ''
  useRegisterDevice: Flag = 1
  returnMethod: ReturnType | string = ''
  useRegisteredAddress: Flag = 1
  defect: string[] = []
  defectDetail: string = ''
  device_register_id?: string = ''
  productSerialNumber: string = ''
  name1?: string = ''
  name2?: string = ''
  name1Furigana?: string = ''
  name2Furigana?: string = ''
  zipcode?: string = ''
  address1?: string = ''
  address2?: string = ''
  address3?: string = ''
  address4?: string = ''
  receipt?: File | null = null
  receiptStorageUrl?: string = ''
  deviceName: string = ''
  deviceType: string = ''
  purchaseDate: string = ''
  purchaseStore: string = ''
  purchaseUrl: string = ''
  branch: string = ''
  branchStaff: string = ''
  warranty: string = ''
  status: number = 0
  repairList: any[] = []
  repairCompletedList: any[] = []

  @Mutation
  clearAll() {
    this.id = ''
    this.useRegisterDevice = 1
    this.returnMethod = 0
    this.useRegisteredAddress = 1
    this.defect = []
    this.defectDetail = ''
    this.device_register_id = ''
    this.productSerialNumber = ''
    this.name1 = ''
    this.name2 = ''
    this.name1Furigana = ''
    this.name2Furigana = ''
    this.zipcode = ''
    this.address1 = ''
    this.address2 = ''
    this.address3 = ''
    this.address4 = ''
    this.receipt = null
    this.receiptStorageUrl = ''
    this.deviceName = ''
    this.deviceType = ''
    this.purchaseDate = ''
    this.purchaseStore = ''
    this.purchaseUrl = ''
    this.branch = ''
    this.branchStaff = ''
    this.warranty = ''
    this.status = 0
    this.repairList = []
    this.repairCompletedList = []
  }

  @Mutation
  setName1(value: string) {
    this.name1 = value
  }
  @Mutation
  setName2(value: string) {
    this.name2 = value
  }
  @Mutation
  setName1Furigana(value: string) {
    this.name1Furigana = value
  }
  @Mutation
  setName2Furigana(value: string) {
    this.name2Furigana = value
  }

  @Mutation
  setDeviceName(value: string) {
    this.deviceName = value
  }
  @Mutation
  setProductSerialNumber(value: string) {
    this.productSerialNumber = value
  }

  @Mutation
  setDeviceType(value: string) {
    this.deviceType = value
  }
  @Mutation
  setIsInput(value: boolean) {
    this.isInput = value
  }
  @Mutation
  setDefectDetail(value: string) {
    this.defectDetail = value
  }
  @Mutation
  setDefect(value: string[]) {
    this.defect = value
  }
  @Mutation
  setDeviceRegisterId(value: string) {
    this.device_register_id = value
  }
  @Mutation
  setId(value: string) {
    this.id = value
  }
  @Mutation
  setUseRegisterDevice(value: Flag) {
    this.useRegisterDevice = value
  }
  @Mutation
  setReturnMethod(value: ReturnType) {
    console.log(value)
    this.returnMethod = value
  }
  @Mutation
  setUseRegisteredAddress(value: Flag) {
    this.useRegisteredAddress = value
  }

  @Mutation
  setZipcode(value: string) {
    this.zipcode = value
  }
  @Mutation
  setAddress1(value: string) {
    this.address1 = value
  }
  @Mutation
  setAddress2(value: string) {
    this.address2 = value
  }
  @Mutation
  setAddress3(value: string) {
    this.address3 = value
  }
  @Mutation
  setAddress4(value: string) {
    this.address4 = value
  }
  @Mutation
  setReceipt(value: File | null) {
    console.log(value)
    this.receipt = value

    console.log(this.receipt)
  }
  @Mutation
  setPurchaseStore(value: string) {
    this.purchaseStore = value
  }
  @Mutation
  setPurchaseDate(value: string) {
    this.purchaseDate = value
  }
  @Mutation
  setPurchaseUrl(value: string) {
    this.purchaseUrl = value
  }
  @Mutation
  setBranch(value: string) {
    this.branch = value
  }
  @Mutation
  setBranchStaff(value: string) {
    this.branchStaff = value
  }
  @Mutation
  setReceiptStorageUrl(value: string) {
    this.receiptStorageUrl = value
  }
  @Mutation
  setWarranty(value: string) {
    this.warranty = value
  }
  @Mutation
  setStatus(value: number) {
    this.status = value
  }

  @Mutation
  setRepairList(value: any[]) {
    this.repairList = value
  }

  @Mutation
  setRepairCompletedList(value: any[]) {
    this.repairCompletedList = value
  }

  @Action({ rawError: true })
  public createRepair() {
    return new Promise<Response<null>>((resolve, reject) => {
      const request: any = {
        use_register_device: this.useRegisterDevice,
        device_type: this.deviceType,
        defect: this.defect,
        defect_detail: this.defectDetail,
        return_method: this.returnMethod,
        use_registered_address: this.useRegisteredAddress,
      }
      if (this.useRegisterDevice == 1) {
        request.device_register_id = this.device_register_id
      } else {
        request.receipt = this.receiptStorageUrl
        request.purchase_date = this.purchaseDate
        request.purchase_store = this.purchaseStore
        request.purchase_url = this.purchaseUrl
        request.warranty = this.warranty
        request.branch = this.branch
        request.branch_staff = this.branchStaff
        // request.purchase_date = this.purchaseDate
      }

      if (this.useRegisteredAddress == 0) {
        request.name_1 = this.name1
        request.name_2 = this.name2
        request.furigana_1 = this.name1Furigana
        request.furigana_2 = this.name2Furigana

        request.zipcode = this.zipcode
        request.address_1 = this.address1
        request.address_2 = this.address2
        request.address_3 = this.address3
        request.address_4 = this.address4
      }
      $axios
        .post(`${process.env.BASE_PATH}/repair`, request)
        .then((result: Response<null>) => {
          console.log(result)
          resolve(result)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
  @Action({ rawError: true })
  public putRepair() {
    return new Promise<Response<null>>((resolve, reject) => {
      const request: any = {
        id: this.id,
        use_register_device: this.useRegisterDevice,
        device_type: this.deviceType,
        defect: this.defect,
        defect_detail: this.defectDetail,
        return_method: this.returnMethod,
        use_registered_address: this.useRegisteredAddress,
      }
      if (this.useRegisterDevice == 1) {
        request.device_register_id = this.device_register_id
      } else {
        request.receipt = this.receiptStorageUrl
        request.purchase_date = this.purchaseDate
        request.purchase_store = this.purchaseStore
        request.purchase_url = this.purchaseUrl
        request.warranty = this.warranty
        request.branch = this.branch
        request.branch_staff = this.branchStaff
        // request.purchase_date = this.purchaseDate
      }

      if (this.useRegisteredAddress == 0) {
        request.name_1 = this.name1
        request.name_2 = this.name2
        request.furigana_1 = this.name1Furigana
        request.furigana_2 = this.name2Furigana
        request.zipcode = this.zipcode
        request.address_1 = this.address1
        request.address_2 = this.address2
        request.address_3 = this.address3
        request.address_4 = this.address4
      }
      $axios
        .put(`${process.env.BASE_PATH}/repair`, request)
        .then((result: Response<null>) => {
          console.log(result)
          resolve(result)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
  @Action({ rawError: true })
  public searchAddress() {
    return new Promise<void>(async (resolve, reject) => {
      const response: any = await axios
        .get(`${process.env.BASE_PATH_V2}/v1/address?zipcode=${this.zipcode}`)
        .catch((e) => {
          reject(e)
          throw e
        })
      console.log(response)
      const address: Address = {
        pref: response.data[0].address1,
        city: response.data[0].address2 + response.data[0].address3,
      }
      this.setAddress1(address.pref)
      this.setAddress2(address.city)

      resolve()
    })
  }
  @Action({ rawError: true })
  public uploadStorage() {
    const ext = getExtentionName(this.receipt!.name)
    this.setReceiptStorageUrl(`receipt/repair/${getUUID()}.${ext}`)
    return uploadStorage(this.receipt!, this.receiptStorageUrl!)
  }

  @Action({ rawError: true })
  public async getRepairs() {
    const result = await $axios.get(`${process.env.BASE_PATH}/repairs`)
    this.setRepairList(getRepairListProgress(result.data.data))
    this.setRepairCompletedList(getRepairListCompleted(result.data.data))
    return result.data
  }

  @Action({ rawError: true })
  public cancelRepair() {
    return new Promise<Response<null>>((resolve, reject) => {
      const request: any = {
        id: this.id,
      }
      $axios
        .put(`${process.env.BASE_PATH}/repair/cancel`, request)
        .then((result: Response<null>) => {
          console.log(result)
          this.setStatus(RepairStatus.Cancel)
          resolve(result)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  @Action({ rawError: true })
  public getRepair(id: string) {
    return new Promise<Response<any>>((resolve, reject) => {
      $axios
        .get(`${process.env.BASE_PATH}/repair?id=${id}`)
        .then(async (result) => {
          console.log(result)
          this.setId(result.data.data.id)
          this.setUseRegisterDevice(result.data.data.use_register_device)
          this.setDeviceRegisterId(result.data.data.device_register_id)
          this.setStatus(result.data.data.status)
          this.setPurchaseDate(result.data.data.purchase_date)
          this.setPurchaseStore(result.data.data.purchase_store)
          this.setPurchaseUrl(result.data.data.purchase_url)
          this.setBranch(result.data.data.branch)
          this.setBranchStaff(result.data.data.branch_staff)
          this.setReceiptStorageUrl(result.data.data.receipt)
          this.setDeviceType(result.data.data.device_type)
          this.setDeviceName(devices[result.data.data.device_type].name)
          this.setDefect(result.data.data.defect)
          this.setDefectDetail(result.data.data.defect_detail)
          this.setReturnMethod(result.data.data.return_method)
          this.setUseRegisteredAddress(result.data.data.use_registered_address)
          this.setWarranty(result.data.data.warranty)
          this.setName1(result.data.data.name_1)
          this.setName2(result.data.data.name_2)
          this.setName1Furigana(result.data.data.furigana_1)
          this.setName2Furigana(result.data.data.furigana_2)
          this.setZipcode(result.data.data.zipcode)
          this.setAddress1(result.data.data.address_1)
          this.setAddress2(result.data.data.address_2)
          this.setAddress3(result.data.data.address_3)
          this.setAddress4(result.data.data.address_4)
          console.log(this.device_register_id)
          resolve(result.data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
}

const getRepairListProgress = (repairList: any[]): any[] => {
  return repairList.filter(
    (element) => Number(element.status) < RepairStatus.Completed
  )
}

const getRepairListCompleted = (repairList: any[]): any[] => {
  return repairList.filter(
    (element) => Number(element.status) >= RepairStatus.Completed
  )
}
